import OutlineFour from '@assets/icons/outline-four.svg'
import { Icon } from './Icon'

export const OutlineFourIcon = Icon(OutlineFour)
